// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore, collection } from "firebase/firestore";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries


// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAlS8qMqtkUNldDoMbHZrNp0b1JPaoDGrI",
  authDomain: "reactschedule-a6db3.firebaseapp.com",
  projectId: "reactschedule-a6db3",
  storageBucket: "reactschedule-a6db3.appspot.com",
  messagingSenderId: "132493327060",
  appId: "1:132493327060:web:04c168bd1d36b54b945941",
  measurementId: "G-E8KL4WG9EC"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
//const analytics = getAnalytics(app);

// Get a Firestore instance
export const firestore = getFirestore(app);

// Get an Auth instance
export const auth = getAuth(app);

function getGroups(userId) {
  return collection(firestore, `users/${userId}/groups`);
}